require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-introducing-sian-teasdale.json") })
        }
      }, "path---news-introducing-sian-teasdale");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-introducing-sian-teasdale!./.cache/json/news-introducing-sian-teasdale.json
// module id = 1425
// module chunks = 231608221292675